var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{attrs:{"dark":""},on:{"click":function($event){return _vm.acessarAreaPublica(_vm.licitacao)}}},[_vm._v(" ÁREA PÚBLICA ")])}
var staticRenderFns = []

export { render, staticRenderFns }